import { React, models, kea, history, resources, selectores, Route, match, validation, createSelectorRx, formfields } from "app/main/std";
import { DatosFacturacionCliente, validarDatosFacturacion } from "../index";
import { IdentificacionComponent } from "app/features/componentes/cliente/identificacion";
import { validarIdentificacion } from "app/logic/cliente";
import { DatosCreditoComp, validarDatosCredito } from "../datoscredito/datoscredito";
import { DatosComercialComponent } from "app/features/componentes/cliente/datosComercial";
import { fa } from "typed-font-awesome";
import { validarEmail } from "app/logic/cliente";

type Entity = models.ClienteDTO;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    editar: models.SeccionesCatalogoClientes;
    readonly?: boolean;
    nuevo: boolean;
}

resources.Cliente.delete

function validar(x: Entity, tipoPersona: models.TipoPersona | null) {
    const datosRep = { idCliente: x.IdRegistro };
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        IdentificacionCliente: x => validarIdentificacion(x.IdentificacionCliente, datosRep, resources.Cliente),
        DatosCredito: async x => await validarDatosCredito(x),
        DatosFacturacion: validation.subrule(() => validarDatosFacturacion(x, tipoPersona))
    };
    return validation.getErrors(rules, x);
}

class Generales extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    tipoPersona = (props: Props) => props.value.IdentificacionCliente!.TipoPersona;
    RecibirCorreoStatusGuia = (props: Props) => props.value.RecibirCorreoStatusGuia;

    errors = createSelectorRx(this.value, this.tipoPersona, validar);
    hasError = createSelectorRx(this.errors, err => validation.hasError(err));
    getField = formfields(() => this.props, () => this.errors(this.props));

    arregloCadena = (props: Props) => props.value.CorreoCliente ? props.value.CorreoCliente.split(";") : [];
    arregloCorreos = createSelectorRx(this.arregloCadena, arreglo => arreglo.filter(x => x != undefined && x != "").map(x => ({ valido: validarEmail(x), correo: x })));

    onEliminarCorreo = async (index: number) => {
        const value = this.props.value;
        const arregloCorreos = this.arregloCorreos(this.props);
        var arreglos = arregloCorreos.filter((x, i) => index != i);
        const nuevoValueCorreo = arreglos.map(x => x.correo).join(";");
        const cambio: Partial<Entity> = { CorreoCliente: nuevoValueCorreo };
        await this.props.onChange({ ...value, ...cambio });
    }

    render() {
        const getField = this.getField;
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const DateTime = getField(kea.DateTime);
        const Tarifa = getField(selectores.Tarifa);
        const Vendedor = getField(selectores.Vendedor);
        const arregloCorreos = this.arregloCorreos(this.props);
        const RecibirCorreoStatusGuia = this.RecibirCorreoStatusGuia(this.props);


        return (
            kea.autogrid(6, [
                <Text field="Nombre" />,
                <Check field="AceptaFletePorCobrar" label="Acepta flete por cobrar" />,
                <Check field="AceptaFxcZe" label="Acepta Flete por cobrar en zonas extendidas" />,
                <Check field="UtilizarConvenioPropioEnFXC" label="Aplicar convenio propio a los envíos FXC" />,
                <Check field="AgruparGuiasAlFacturar" label="Agrupar guías al facturar" />,
                <Check field="RecibirCorreoStatusGuia" label="Recibir correo de status de guía" />,
                RecibirCorreoStatusGuia ? <div>
                    <p><strong>Correo de cliente</strong></p>
                    {
                        arregloCorreos.map((x, i) => <span style={{ color: "black", backgroundColor: x.valido ? "#E3FBCA" : "#FBD2CA" }} className="badge">{x.correo} {' '} <kea.IconButton onClick={() => this.onEliminarCorreo(i)} style="danger" iconClass={fa("times")} />  </span>)
                    }
                    <Text field="CorreoCliente" label="" />
                </div> : null,
                <Tarifa field="IdTarifa" label="Tarifa / convenio" />,
                <Vendedor field="IdVendedor" label="Vendedor" />,
                <DateTime field="FechaDeInicioParaComisiones" label="Fecha de inicio para comisiones" />,
                <Text field="Telefono" label="Teléfono" />,
                <Check field="SoloRecibirContactosAutorizado" label="Solamente entregar paquetes a contactos autorizados" />,
                <Check field="ImprimirPrecioGuiaPP" label="imprimir precio en guias pp" />,
                <Check field="ImprimirPrecioGuia" label="imprimir precio en guias" />,
                kea.autogrid(6, [<Check field="SeguroViaje" label="Cobrar seguro" />,
                <Text field="NumeroPoliza" label="Numero de póliza del cliente" />]),
                
                <Check field="CalculoEspecialDeGuias" label="Calculo Especial para el total de las Guias" />,
                <Check field="TomarSucursalCobranzaDefault" label="Usar Sucursal de cobranza al realizar facturas" />,
                <Check field="CobrarImporteGastoAdministrativo" label="Cobrar importe de gasto administrativo por guia" />,
                <Check field="CartaPorteEspecialSepararGuias" label="Separar guias al timbrar carta porte EAD" />,

                <Check field="AumentarPresicionDeDecimales" label="Aumentar presicion de decimales" />

            ])
        )
    }
}



/**
* Componente para editar un Entity
*/
export class AuxiliarClienteForm extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    tipoPersona = (props: Props) => props.value.IdentificacionCliente!.TipoPersona;
    datosRep = createSelectorRx(this.value, x => ({ idCliente: x.IdRegistro }));

    errors = createSelectorRx(this.value, this.tipoPersona, validar);
    hasError = createSelectorRx(this.errors, err => validation.hasError(err));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo, onChange, } = this.props;
        const tipoPersona = this.tipoPersona(this.props);
        const getField = this.getField;

        const Check = getField(kea.Checkbox);
        const Identificacion = getField(IdentificacionComponent);
        const DatosComercial = getField(DatosComercialComponent);
        const hasError = this.hasError(this.props);
        return (
            <div>
                <kea.Panel title="General" style="success">
                    <Generales {... this.props} readonly={this.props.readonly || !this.props.editar.General} />
                </kea.Panel>
                <DatosComercial
                    field="DatosComercialCliente"
                    //datosRep={this.datosRep(this.props)} 
                    //resourceRep={resources.Cliente }
                    readonly={this.props.readonly || !this.props.editar.Comercial}
                />
                <Identificacion
                    field="IdentificacionCliente"
                    datosRep={this.datosRep(this.props)}
                    resourceRep={resources.Cliente}
                    readonly={this.props.readonly || !this.props.editar.Identificacion}
                /> 
                <DatosFacturacionCliente
                    value={value}
                    onChange={onChange}
                    tipoPersona={tipoPersona}
                    readonly={this.props.readonly || !this.props.editar.Facturacion}
                />
                <DatosCreditoComp
                    value={this.props.value}
                    onChange={this.props.onChange}
                    readonly={this.props.readonly || !this.props.editar.CreditoCobranza}
                />
                <kea.Panel title="Clientes" style="success">
                    {kea.autogrid(6, [
                        <Check field="VerSoloClientesRelacionados" label="Ver solo los clientes relacionados con el cliente"
                            readonly={this.props.readonly || !this.props.editar.ClientesRelacionados}
                        />,
                        <Check field="VisibleExclusivoClientesRelacionados" label="Exclusivo para los clientes que lo tengan relacionado"
                            readonly={this.props.readonly || !this.props.editar.ClientesRelacionados}
                        />
                    ])}
                </kea.Panel>

                <kea.Panel title="Paquetes" style="info">
                    <Check field="VerSoloDescripcionesPaquetesRelacionados" label="Ver solo las descripciones de los paquetes relacionados con el cliente"
                        readonly={this.props.readonly || !this.props.editar.Paquetes}
                    />

                </kea.Panel>
                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/auxiliarclienteform.tsx